import React from "react";
import OrderHeader from "../OrderSuccess/OrderHeader";
import OrderSuccesCheckOut from "../OrderSuccess/OrderSuccesCheckOut";
import { useSelector, useDispatch } from "react-redux";
import OrderSuccesProducts from "../OrderSuccess/OrderSuccesProducts";
import { useEffect } from "react";
import {
  setpaymentUpdateOrderClear,
  updateOrder,
} from "../../redux/order/OrderSlice";

const PendingPaaymentStatus = () => {
  const { currentOrder, paymentUpdateOrder } = useSelector(
    (state) => state.Order
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (paymentUpdateOrder !== "") {
      const updateOrderss = async () => {
        const orderPaymentForm = {
          orderid: paymentUpdateOrder._id,
          PaymentStatus: "PENDING",
          CurrentStatus: "Not Paid",
          TxnId: "NA",
          PaymentMode: "PayTM",
          GrandTotal: paymentUpdateOrder.GrandTotal,
        };
        await dispatch(updateOrder(orderPaymentForm));
        await dispatch(setpaymentUpdateOrderClear(""));
      };
      updateOrderss();
    }
  }, [paymentUpdateOrder]);
  return (
    <>
      <section className="breadscrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadscrumb-contain breadscrumb-order">
                <div className="order-box">
                  <div className="order-image">
                    <div
                      className="checkmark"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src="/assets/images/preorder.png"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                  <div className="order-contain">
                    <h3
                      className=""
                      style={{ color: "#00ab66", fontSize: "18px" }}
                    >
                      Your Order Payment Was Pending. We will update your order
                      status soon. In case of need please call @ 88777 79770.
                    </h3>
                    <h5
                      className="text-content"
                      style={{ color: "#00ab66", fontWeight: "bold" }}
                    >
                      Your Order Was Successfully Placed on Cash On Delivery.
                    </h5>
                    {/* <h6>
                    Order ID:
                      <span style={{ textTransform: "uppercase" }}>
                        {currentOrder._id.slice(18)}
                      </span>
                    </h6> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cart-section section-b-space">
        <div className="container-fluid-lg">
          <div className="row g-sm-4 g-3">
            <OrderSuccesProducts />
            <OrderSuccesCheckOut />
          </div>
        </div>
      </section>
    </>
  );
};

export default PendingPaaymentStatus;
